import React, { useContext } from 'react'
import MenuBarComponent from '../Components/MenuBarComponent';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import placePicture from '../images/hands_two.jpg'
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { loginService } from '../Service/UserService';
import { toast } from 'react-toastify';
import AuthContext from '../Contexts/AuthContext';

function Login() {
    const {setUserAuth} = useContext(AuthContext)
    const { t } = useTranslation('login');
    const navigate = useNavigate()
    
    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
      } = useForm();

    const sideClassStyle = `p-4 md:p-8 mx-4 md:mx-8 gap-4 md:gap-8
        flex justify-content-center flex-column-reverse md:flex-row`

    const onSubmit = (e) => {
        const {email, password} = e
        loginService(email, password).then(res=>{
            if (res?.user) {
                setUserAuth(res)
                navigate('/app/user_home_events')
            } else toast.error(t('login_invalid_message'))
        }).catch(error=>{
            console.log(error)
            toast.error(t('login_invalid_message'))
        })
    }

    return (
        <div className='flex flex-column gap-4 background-accent-one'>
            <MenuBarComponent />
            <Tooltip target={'.is_public_message'} />
            <div className={sideClassStyle} style={{borderRadius: '0.5rem'}}>
                <div className='w-12 md:w-6 flex flex-column gap-2'>
                    <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-2'>
                        <div className='flex flex-column gap-1'>
                            <label>{t('email')}</label>
                            <InputText className='w-full' {...register('email', {
                                required: t('email_validation_message'),
                            })} />
                            {errors.email && <span className='form-validation-message'>{errors.email.message}</span>}
                        </div>
                        
                        <div className='flex flex-column gap-1'>
                            <label>{t('password')}</label>
                            <InputText type='password' className='w-full' {...register('password', { 
                                required: t('password_validation_message'),
                            })} />
                            {errors.password && <span className='form-validation-message'>{errors.password.message}</span>}
                        </div>

                        <div className='flex flex-column gap-2 align-items-center'>
                            <div className='flex gap-2 justify-content-center'>
                                <Button type='submit' label={t('enter')} className='background-primary' />
                                <Button type='button' label={t('cancel')} className='background-secondary' onClick={()=>navigate('/')} />
                            </div>
                            <Button type='button' label={t('register')} outlined className='text-color-primary w-max' onClick={()=>navigate('/register')} />
                            <Button type='button' text label={t('forgot_password')} className='text-color-primary w-max' onClick={()=>navigate('/recover_password')} />
                        </div>
                    </form>
                </div>
                <div className='w-12 md:w-6 flex flex-column gap-2 md:gap-4'>
                    <div className='text-2xl md:text-4xl font-bold'>{t('login_title')}</div>
                    <div className='text-xl md:text-2xl'>{t('login_message')}</div>
                    <img src={placePicture} alt='place_picture' />
                </div>
            </div>
        </div>
)
}

export default Login